module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8011.b6c165dc.png";